import React, { useEffect, useState } from "react";
import BasisTableComponent from "../table/BasisTableComponent";

const Project = () => {

    const [ projects, setProjects ] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, pages: 1 });
    const [ loading, setLoading ] = useState(false);
    const [noResults, setNoResults] = useState(false);


    const fetchProjects = async (page = 1) => {
        setLoading(true);
        try {
          const res = await fetch(
            `https://promaster.areez.co/api/projects/list?page=${page}&per_page=20`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user")}`,
                "Content-Type": "application/json",
              },
            }
          );
          const result = await res.json();
          const data = result.projects || [];
      
          setPagination({
            page: result.page || 1,
            pages: Math.ceil(result.total_projects / 20),
          });
          setProjects(data);
        } catch (err) {
          console.error("فشل في تحميل المشاريع:", err);
          setProjects([]);
        } finally {
          setLoading(false);
        }
      };
      

    useEffect(() => {
        fetchProjects(1);
      }, []);

      const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.pages) {
            fetchProjects(newPage);
        }
      };

      const columns = [
        // { label: "#", render: (_, i) => i + 1 },
        { label: "#", field: "project_id" },
        { label: "اسم المشروع", field: "project_name" },
        { label: "الجهة المالكة", field: "company_name" },
        { label: "تاريخ الإنشاء", render: row => new Date(row.create_date).toLocaleDateString("ar-EG") },
        { label: "تفاصيل", field: "actions" },
      ];
      
      


    return (
 <div className="mt-3" style={{fontFamily:"Cairo"}}>
      {loading ? (
        <p className="text-center">جاري التحميل...</p>
      ) : noResults ? (
        <p  className="text-center">لا توجد نتائج.</p>
      ) : (
        <>
          <BasisTableComponent 
            data={projects} 
            columns={columns} 
            pagination={pagination}
            onPageChange={handlePageChange} />
        </>
      )}
    </div>
    )
}

export default Project;